import { AutomationTaskInput } from 'generated-graphql/graphql';
import {
  AutomationActionType,
  AutomationTaskInput as AutomationTaskInputDeprecated
} from 'services/automation/types';

export const automationTasksTrackingEventMapper = (
  automationTasks: (AutomationTaskInput | AutomationTaskInputDeprecated)[]
) => {
  const actionTypes = new Set(automationTasks.map((task) => task.action.type));

  return {
    automationTriggerAction:
      actionTypes.size > 1 &&
      !actionTypes.has(AutomationActionType.UPDATE_CANDIDATE_STATUS),
    automationTriggerActionSendCampaign: actionTypes.has(
      AutomationActionType.SEND_CAMPAIGN
    ),
    automationTriggerActionRejectionEmail: actionTypes.has(
      AutomationActionType.SEND_EMAIL
    ),
    automationTriggerActionUpdateAts: actionTypes.has(
      AutomationActionType.UPDATE_ATS
    ),
    automationTriggerActionJobRecommendation: actionTypes.has(
      AutomationActionType.SEND_JOB_RECOMMENDATION_EMAIL
    ),
    automationStatusChange: actionTypes.has(
      AutomationActionType.UPDATE_CANDIDATE_STATUS
    )
  };
};
